export const beatsPerMeasure = 8;

import songIntro from './songIntro';
import songVerse1 from './songVerse1';

export const songNotes = songIntro.concat(
    songVerse1
);